import { render, staticRenderFns } from "./PPublicStatusRadios.vue?vue&type=template&id=3c5d8ad1&scoped=true&"
import script from "./PPublicStatusRadios.vue?vue&type=script&lang=ts&"
export * from "./PPublicStatusRadios.vue?vue&type=script&lang=ts&"
import style0 from "./PPublicStatusRadios.vue?vue&type=style&index=0&id=3c5d8ad1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5d8ad1",
  null
  
)

export default component.exports